<form [formGroup]="formulario">
  <div class="row">
    <div class="col-2">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>ID</mat-label>
        <input formControlName="id" matInput readonly>
      </mat-form-field>
    </div>
    <div class="col-2">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>CodCliente</mat-label>
        <input required maxlength="13" formControlName="codCliente" (change)="buscarCliente.emit()" mask="separator.0" matInput>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Cliente</mat-label>
        <input required matInput formControlName="cliente" readonly>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Dt Emprestimo</mat-label>
        <input required matInput formControlName="dtEmprestimo" mask="00/00/0000">
      </mat-form-field>
    </div>
    <div class="col-1">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>CodProduto</mat-label>
        <input required maxlength="13" formControlName="codProduto" (change)="buscarProduto.emit()" mask="separator.0" matInput>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Produto</mat-label>
        <input required matInput formControlName="produto" readonly>
      </mat-form-field>
    </div>
    <div class="col-1">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Quantidade</mat-label>
        <input required maxlength="13" formControlName="quantidade" mask="separator.0" matInput>
      </mat-form-field>
    </div>
    <div class="col-2">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Nº Quantidade</mat-label>
        <input formControlName="numeroQuantidade" matInput readonly>
      </mat-form-field>
    </div>
    <div class="col-2">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Previsão Devolução</mat-label>
        <input matInput formControlName="dtPrevisaoDevolucao" mask="00/00/0000">
      </mat-form-field>
    </div>
    <div class="col-2">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Devolução</mat-label>
        <input matInput formControlName="dtDevolucao" mask="00/00/0000">
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field class="full-width w-100" appearance="fill">
        <mat-label>Observação</mat-label>
        <textarea required formControlName="observacao" matInput></textarea>
      </mat-form-field>
    </div>
  </div>
</form>
